import { icons, images } from "assets";
import Hidden from "Components/shared/hidden";
import Text from "Components/shared/text";
import {
  HIDE_BALANCE,
  SHOW_BALANCE,
  useBalanceDispatch,
  useBalanceStore,
} from "providers/balance";
import React, { useState } from "react";
import { useEffect } from "react";
import { Storage } from "utils/clientStorage";
import styles from "./header.module.css";

// import {SCREEN_SIZE} from 'Components/ '

export const Header = ({ hidden }) => {
  const { showBalance } = useBalanceStore();
  const balDispatch = useBalanceDispatch();

  const [firstName, setFirstName] = useState(null);

  useEffect(() => {
    const profile = Storage.getItem("PROFILE");
    setFirstName(profile.firstName);
  }, []);

  return (
    <Hidden smDown>
      <Text
        tag="div"
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 1rem 1rem 1rem",
        }}
      >
        {hidden ? null : (
          <Text tag="div">
            <Text tag="div" className={styles.header}>
              <img
                src={images.profileImage}
                alt="PROFILE"
                style={{ width: "40px", height: "50px", borderRadius: "10%" }}
              />
              <Text tag="div">
                <Text style={{ fontWeight: 600 }} variant="md2">
                  Hi {firstName},
                </Text>
                <Text variant="xs" style={{ color: "var(--disabled-color)" }}>
                  Welcome back on baord
                </Text>
              </Text>
            </Text>
          </Text>
        )}
        <Text tag="div" className={styles.header}>
          <Text
            tag="div"
            className={styles.header}
            style={{
              backgroundColor: "white",
              padding: ".7rem",
              borderRadius: "10px",
              cursor: "pointer",
            }}
            onClick={() =>
              balDispatch({ type: showBalance ? HIDE_BALANCE : SHOW_BALANCE })
            }
          >
            <img
              src={showBalance ? icons.eye_close : icons.open_eye}
              width={16}
            />
            <Text variant="xs">
              {showBalance ? "Hide Balance" : "Show Balance"}
            </Text>
          </Text>
          <Text
            tag="div"
            className={styles.header}
            style={{
              backgroundColor: "white",
              padding: ".7rem",
              borderRadius: "10px",
            }}
          >
            <img
              src={images.profileImage}
              style={{ width: "20px", hieght: "20px", borderRadius: "50%" }}
            />
            <Text variant="xs">Profile</Text>
          </Text>
        </Text>
      </Text>
    </Hidden>
  );
};
